/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamBookingRunSummaryStudentName } from './oralExamBookingRunSummaryStudentName';
import type { OralExamIdVerificationState } from './oralExamIdVerificationState';
import type { OralExamBookingRunSummaryIdPhotoBlobPath } from './oralExamBookingRunSummaryIdPhotoBlobPath';
import type { OralExamBookingRunSummaryIdSelfiePhotoBlobPath } from './oralExamBookingRunSummaryIdSelfiePhotoBlobPath';
import type { OralExamSupervisorStatus } from './oralExamSupervisorStatus';
import type { OralExamPresenceLocation } from './oralExamPresenceLocation';
import type { OralExamReadiness } from './oralExamReadiness';
import type { OralExamRunStateResponse } from './oralExamRunStateResponse';

/**
 * Per-booking run summary for the lecturer cohort console.
 */
export interface OralExamBookingRunSummary {
  bookingId: string;
  studentId: string;
  studentName?: OralExamBookingRunSummaryStudentName;
  courseId: string;
  moduleId: string;
  taskId: string;
  idVerification: OralExamIdVerificationState;
  idPhotoBlobPath?: OralExamBookingRunSummaryIdPhotoBlobPath;
  idSelfiePhotoBlobPath?: OralExamBookingRunSummaryIdSelfiePhotoBlobPath;
  supervisorStatus: OralExamSupervisorStatus;
  isAdmitted: boolean;
  hasRecording?: boolean;
  present?: boolean;
  presenceLocation?: OralExamPresenceLocation;
  readiness?: OralExamReadiness;
  examinerSilent?: boolean;
  runState: OralExamRunStateResponse;
}
